export const MULTIPLAYER_NET_CONFIG = {
  maxPlayers: 4,
  hostSimulationHz: 60,
  snapshotHz: 20,
  snapshotHeartbeatLogHz: 1,
  interpolationDelayMs: 100,
  largeCorrectionWarnDistance: 48,
  largeSnapshotTickJumpWarn: 10,
  debugLatencyMs: 0,
  debugJitterMs: 0,
  debugPacketDropRate: 0,
  maxQueuedInboundMessages: 240,
};
